import React, { useState } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link, NavLink, useNavigate } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Home, Menu, Search, ShoppingBag, User, X } from "lucide-react";

function Header() {
  const [showSearchModal, setShowSearchModal] = useState(false);
   const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const navigate = useNavigate();

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  


  // const navigate = useNavigate();

  // Helper: Close Bootstrap Offcanvas & Navigate
  // const closeMenuAndNavigate = (path) => {
  //   const closeBtn = document.querySelector('[data-bs-dismiss="offcanvas"]');
  //   if(closeBtn) closeBtn.click();
  //   navigate(path);
  // };

  const closeMenuAndNavigate = (path) => {
    const closeBtn = document.querySelector('[data-bs-dismiss="offcanvas"]');
    if(closeBtn) closeBtn.click();
    // navigate(path);
    navigate(path);
  };

  return (
    <>

      {/* marquee-section  */}

      <div className="announcement-bar">
        <div className="marquee-wrapper">
          <div className="marquee-content">
            <span>COMPLIMENTARY SAMPLES ON ORDERS OVER Rs.50</span>
            <span className="separator">•</span>
            <span>FREE SHIPPING WORLDWIDE</span>
            <span className="separator">•</span>
            <span>ORGANIC INGREDIENTS</span>
            <span className="separator">•</span>
            <span>COMPLIMENTARY SAMPLES ON ORDERS OVER Rs.50</span> 
          </div>
        </div>
      </div>


       {/* 2. Main Header (Top) */}
      <header className="skin-header sticky-top">
        <div className="container px-3">
          <div className="d-flex justify-content-between align-items-center" style={{ height: 'var(--header-height)' }}>
            
            {/* LEFT: Mobile Toggle + Desktop Nav */}
            <div className="d-flex align-items-center">
              <button className="icon-btn d-lg-none me-2" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu">
                {/* <FaBars size={22} /> */}
                <Menu size={22} />
              </button>
              
              <nav className="d-none d-lg-flex">
                <NavLink to="/shop" className="nav-link-custom text-decoration-none">Shop</NavLink>
                <Link to="/about-us" className="nav-link-custom text-decoration-none">About</Link>
                 <Link to="/blog" className="nav-link-custom text-decoration-none">Blog</Link>
                <Link to="/contact-us" className="nav-link-custom text-decoration-none">Contact</Link>
              </nav>
            </div>

            {/* CENTER: Brand Logo with Breathing Animation */}
            <div className="position-absolute start-50 translate-middle-x">
              <NavLink to="/" className="brand-text d-flex align-items-center gap-2">
                {/* <FaLeaf size={16} className="logo-icon"/> */}
                 {/* AURA & LEAF */}
                 <img src={config?.logo} alt="logo" className="logo-img" />
              </NavLink>
            </div>

            {/* RIGHT: DESKTOP ONLY Actions */}
            <div className="d-none d-lg-flex align-items-center gap-3">
              {/* <button className="icon-btn" onClick={() => setIsSearchOpen(true)}>
                <Search size={18} />
              </button> */}
               <span data-bs-toggle="modal" data-bs-target="#searchModal" className="icon-btn text-dark">
                <Search size={22} />
              </span>
              
              <Link to={isLoggedIn ? "/users/dashboard" : "/users/login"}  className="icon-btn">
                <User size={18} />
              </Link>

              <button className="icon-btn position-relative" data-bs-toggle="offcanvas" data-bs-target="#cartDrawer">
                <ShoppingBag size={18} />
                {cartItems.length > 0 && <span className="badge-count pulse-badge">{cartItems.length}</span>}
                 {/* {cartItems.length} */}
              </button>
            </div>

            <div className="d-lg-none" style={{width: '24px'}}></div>
          </div>
        </div>
      </header>
     

       {/*  3. UNIQUE: "FLOATING ISLAND" BOTTOM NAV (Mobile Only)  */}
      <div className="island-nav-container d-lg-none">
        <div className="island-nav glass-panel">
          
          <NavLink to="/" className={({ isActive }) => `island-item ${isActive ? 'active' : ''}`}>
            <div className="icon-wrapper"><Home /></div>
          </NavLink>

          {/* <button className="island-item" onClick={() => setIsSearchOpen(true)}>
            <div className="icon-wrapper"><Search /></div>
          </button> */}

          
          <span data-bs-toggle="modal" data-bs-target="#searchModal"  className="island-item">
            <div className="icon-wrapper"><Search /></div>
          </span>

          <Link to={isLoggedIn ? "/users/dashboard" : "/users/login"}   style={{ textDecoration: "none", color:"rgba(255, 255, 255, 0.5)" }}   className={({ isActive }) => `island-item ${isActive ? 'active' : ''}`}>
            <div className="icon-wrapper"><User /></div>
          </Link>

          <button className="island-item position-relative" data-bs-toggle="offcanvas" data-bs-target="#cartDrawer">
            <div className="icon-wrapper">
              <ShoppingBag />
              {cartItems.length > 0 && <span className="island-badge"></span>}
            </div>
          </button>

        </div>
      </div>

       {/* --- SEARCH OVERLAY --- */}
      {/* {isSearchOpen && (
        <div className="search-overlay">
          <div className="container text-center position-relative w-100 h-100 d-flex flex-column justify-content-center">
            <button className="position-absolute icon-btn" style={{top: '20px', right: '20px', fontSize: '2rem', zIndex: 2005}} onClick={() => setIsSearchOpen(false)}>
              <X />
            </button>
            <h2 className="drawer-title mb-4">Search our collection</h2>
            <input type="text" className="search-input-minimal mx-auto" placeholder="Type to search..." autoFocus />
          </div>
        </div>

         
      )} */}


 <div
        className="modal fade popup-search"
        id="searchModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <SearchCanvas isOpen={showSearchModal} />
      </div>

       <div className="offcanvas offcanvas-end" id="cartDrawer" tabIndex="-1">
        <CartCanvas/>
       </div>





       {/* --- SIDE MENUS (Unchanged functionality, styled below) --- */}
      <div className="offcanvas offcanvas-start" id="mobileMenu" tabIndex="-1">
        <div className="offcanvas-header border-bottom">
          <h5 className="m-0 drawer-title">MENU</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body p-4">
          <ul className="list-unstyled d-flex flex-column gap-3">
            <li><button className="mobile-link-btn w-100 text-start" onClick={() => closeMenuAndNavigate('/')}>Home</button></li>
            <li><button className="mobile-link-btn w-100 text-start" onClick={() => closeMenuAndNavigate('shop')}>Shop All</button></li>
            <li><button className="mobile-link-btn w-100 text-start" onClick={() => closeMenuAndNavigate('about-us')}>About</button></li>
            <li><button className="mobile-link-btn w-100 text-start" onClick={() => closeMenuAndNavigate('/contact-us')}>Contact</button></li>
          </ul>
        </div>
      </div>

    
    </>
  );
}

export default Header;













